import { ICommand, IDefineCommand, IQuery, IQueryMediator } from 'core-ts-types';
import { IAppointmentReasonTypeDatasource } from '../datasources/appointment_reason_type_datasource';
import { AppointmentsCommandServant } from '../servants/appointments_command_servant';
import { IStudentServiceCategory } from '../types/appointment_interfaces';

angular
  .module('capability-ng-appointments')
  .factory(
    'loadAppointmentTypeConfigurationServiceCommand',
    (
      defineCommand: IDefineCommand,
      $http: ng.IHttpService,
      QueryMediator: IQueryMediator,
      ngAppointmentsCommandServant: AppointmentsCommandServant,
      ngAppointmentReasonTypeDatasource: IAppointmentReasonTypeDatasource,
      log: any
    ): ICommand => {
      return defineCommand(
        'loadAppointmentTypeConfigurationServiceCommand',
        (deferred: ng.IDeferred<IQuery[]>): void => {
          ngAppointmentsCommandServant
            .request({
              url: 'scheduler_configs',
              method: 'GET'
            })
            .then(({ data }: ng.IHttpPromiseCallbackArg<any>) => {
              ngAppointmentReasonTypeDatasource
                .includeModel({
                  appointment_type_instructions: data.appointment_type_instructions
                })
                .write(data.appointment_types);
              QueryMediator.runQueries(ngAppointmentReasonTypeDatasource);
              deferred.resolve();
            })
            .catch(() => {
              log.error('Unable to get appointment type configuration');
              deferred.reject();
            });
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-appointments/src/commands/load_appointment_type_configuration_service_command.ts